import { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Navigation, Thumbs } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import YouTube from 'react-youtube';
import Image from 'next/image';

const videos = [
  { videoId: 'mLygmNHVcic', title: 'Introducción al ERP CIGE PERU' },
  { videoId: 'BGWBiFIAHIE', title: 'Cómo Crear una Factura Automatizada en Excel (Impresión en PDF)' },
  { videoId: '14siJdBBmJg', title: 'Módulo de Ventas del ERP CIGE' },
  { videoId: 'JB3PGq2F4uo', title: 'Proceso de Compras Locales en el ERP CIGE' },
  { videoId: 'vQ-aFzKs-lg', title: 'FILTRAR todas LAS COLUMNAS de una tabla MIENTRAS ESCRIBES sin la Función Filtrar de Excel' },
  { videoId: 'VghkNlTYUTM', title: 'Proceso de Importación en el ERP CIGE' },
];

const VideoCarousel = () => {
  const [thumbsSwiper, setThumbsSwiper] = useState<any>(null);

  return (
    <div className="relative">
      {/* Contenedor del Video Principal */}
      <div className="relative w-full max-w-4xl mx-auto mb-8">
        <Swiper // Carrusel principal para mostrar los videos
          modules={[FreeMode, Navigation, Thumbs]} 
          spaceBetween={10} 
          slidesPerView={1} 
          thumbs={{ swiper: thumbsSwiper }} 
          className="video-carousel" 
/*           navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }} // Añadir navegación */
        >
          {videos.map((video) => (
            <SwiperSlide key={video.videoId}> 
              <div className="relative w-full h-0 pb-[56.25%]"> 
                <YouTube 
                  videoId={video.videoId} 
                  opts={{ height: '100%', width: '100%' }} 
                  className="absolute top-0 left-0 w-full h-full" 
                />
              </div>
            </SwiperSlide>
          ))}
          {/* Flechas de navegación en el carrusel principal */}
{/*           <div className="swiper-button-prev" /> 
          <div className="swiper-button-next" />  */}
        </Swiper>
      </div>

      {/* Miniaturas con flechas de navegación */}
      <div className="w-full max-w-4xl mx-auto mt-8 relative"> 
        <Swiper // Carrusel de miniaturas
          onSwiper={setThumbsSwiper}
          spaceBetween={10}
          slidesPerView={4}
          freeMode={true}
          watchSlidesProgress={true}
          modules={[FreeMode, Navigation, Thumbs]}
          className="video-carousel2" 
          navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }} // Añadir navegación
          scrollbar={{ el: '.swiper-scrollbar' }}// And if we need scrollbar
      
        >
          {videos.map((video) => (
            <SwiperSlide key={video.videoId}> 
  
  
<Image 
  src={`https://img.youtube.com/vi/${video.videoId}/mqdefault.jpg`}
  alt={video.title}
  width={320} // Ajusta el ancho según sea necesario
  height={180} // Ajusta la altura según sea necesario
  className="w-full h-auto rounded-lg"
/>
              <p className="text-center text-sm mt-2">{video.title}</p> 
            </SwiperSlide>
          ))}
          {/* Flechas de navegación en las miniaturas */}
          <div className="swiper-button-prev" /> 
          <div className="swiper-button-next" /> 
        </Swiper>
      </div>
    </div>
  );
};

export default VideoCarousel;
